// import Cookies from 'js-cookie';
import { getLanguage } from '@/lang/index';

const state = {
	sidebar: {
		opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
		withoutAnimation: false
	},
	device: 'desktop',
	language: getLanguage(),
	size: Cookies.get('size') || 'medium',
	subBrandList: [],
	channelList: [],
	skillGroupLists:[],
	StoreIsKnowledge: false,
	isShowTips:false,
	isShowPhone: false,
	virtual_host: '',
	StoreVersion: 'v2.1.8',
	isLogin: false,
}

const mutations = {
	SET_IS_LOGIN: (state, isLogin) => {
		state.isLogin = isLogin;
	},
	SET_VIRTUAL_HOST: (state, virtual_host) => {
		state.virtual_host = virtual_host;
	},
	SET_IS_SHOW_PHONE: (state, isShowPhone) => {
		localStorage.setItem('GlobalIsShowPhone', isShowPhone);
		state.isShowPhone = isShowPhone;
	},
	SET_IS_SHOWtIPS: (state, data) => {
		state.isShowTips = data
	},
	SET_IS_KNOWLEDGE: (state, StoreIsKnowledge) => {
		console.log(StoreIsKnowledge)
		state.StoreIsKnowledge = StoreIsKnowledge;
	},
	TOGGLE_SIDEBAR: state => {
		state.sidebar.opened = !state.sidebar.opened;
		state.sidebar.withoutAnimation = false;
		if (state.sidebar.opened) {
			Cookies.set('sidebarStatus', 1);
		} else {
			Cookies.set('sidebarStatus', 0);
		}
	},
	CLOSE_SIDEBAR: (state, withoutAnimation) => {
		Cookies.set('sidebarStatus', 0);
		state.sidebar.opened = false;
		state.sidebar.withoutAnimation = withoutAnimation;
	},
	TOGGLE_DEVICE: (state, device) => {
		state.device = device;
	},
	SET_LANGUAGE: (state, language) => {
		state.language = language;
		Cookies.set('language', language);
	},
	SET_SIZE: (state, size) => {
		state.size = size;
		Cookies.set('size', size);
	},
	SET_BASIS_APP: (state, data) => {
		state.subBrandList.length = 0;
		state.channelList.length = 0;
		// state.skillGroupLists.length = 0
		for(let item of data[0]['data']) {
			state.subBrandList.push({
				id: item.brandIdentify,
				name: item.brandName
			});
		}
		for(let item of data[1]['data']) {
			state.channelList.push({
				id: item.channelIdentify,
				name: item.channelName
			});
		}
		localStorage.setItem('dashboard-ocs-channelList-list', JSON.stringify(state.channelList));
		// for(let item of data[2]['data']) {
		// 	state.skillGroupLists.push({
		// 		id: item.skillId,
		// 		name: item.skillName
		// 	});
		// }
	}
}

const actions = {
	toggleSideBar({ commit }) {
		commit('TOGGLE_SIDEBAR');
	},
	closeSideBar({ commit }, { withoutAnimation }) {
		commit('CLOSE_SIDEBAR', withoutAnimation);
	},
	toggleDevice({ commit }, device) {
		commit('TOGGLE_DEVICE', device);
	},
	setLanguage({ commit }, language) {
		commit('SET_LANGUAGE', language);
	},
	setSize({ commit }, size) {
		commit('SET_SIZE', size);
	},
	StoreGetApp({commit}, data) {
		Vue.prototype.$api.apiGetApp(data).then(response => {
			commit('SET_BASIS_APP', response);
		});
	}
}

export default {
	namespaced: true,
	state, 
	mutations,
	actions
}
